








import { Component, Vue, Prop } from 'vue-property-decorator';
import ViewpointCreator from '@/views/Viewpoint/ViewpointCreator.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import CardTitle from '@/components/common/CardTitle.vue';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import { getModule } from "vuex-module-decorators";

const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ViewpointCreator,
        DescriptionEditor,
        CardTitle,
    },
})
export default class ViewpointManager extends Vue {
    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get openRight() {
        return workspaceOptionsModule.openRight;
    }

    get mainContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }

        if (this.appEmbed) {
            return `min-height: calc(100vh - 38px - ${commentHeight}px); 
                    max-height: calc(100vh - 38px - ${commentHeight}px);`;
        } else {
            return `min-height: calc(100vh - 130px - ${commentHeight}px); 
                    max-height: calc(100vh - 130px - ${commentHeight}px);`;
        }
    }
}
